import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function InvoiceStatusTable(props) {
  return (
    <div>
      <div className="sb-table-div sb-table-setion">
        <Paper
          sx={{ width: "100%", overflow: "hidden" }}
          className="table-main-div"
        >
          <TableContainer
          //   onScroll={(e) =>
          //     handleScroll(
          //       e,
          //       props.users,
          //       props.totalUserCount,
          //       props.setLoading,
          //       props.setPageSize,
          //       props.PageSize
          //     )
          //   }
          >
            <Table
              stickyHeader
              aria-label="sticky table table-responsive"
              className="invoice-status-table"
            >
              <TableHead className="custom-table-header">
                <TableRow>
                  {props.tableHeader.map((data, i) => (
                    <TableCell key={i} align={data?.align} sx={data.width}>
                      {data?.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.tableData.map((data, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <div className="color-green">
                        <b>{data?.inv_Doc_No}</b>
                      </div>
                    </TableCell>
                    <TableCell>{data?.invDoc_Date}</TableCell>
                    <TableCell>
                      <div className="color-green"> {data?.po_DocEntry}</div>
                    </TableCell>
                    <TableCell>{data?.poDoc_Date}</TableCell>
                    <TableCell sx={props.setWidthToMaxContent}>
                      {data?.vendor_Ref_No}
                    </TableCell>
                    <TableCell sx={props.setWidthToMaxContent}>
                      {data?.vendor_Name}
                    </TableCell>
                    <TableCell sx={props.setWidthToMaxContent}>
                      {data?.inv_Amount}
                    </TableCell>
                    <TableCell align="center">
                      <div className="attachment">
                        <i className="fa fa-paperclip" />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className="attachment">
                        <i className="fa fa-paperclip" />
                      </div>
                    </TableCell>
                    <TableCell align="center" sx={{ width: "120px" }}>
                      <div
                        className={`invoice depat-status ${data.dept_status}`}
                      >
                        <span className="status-text">{data?.dept_status}</span>
                      </div>
                    </TableCell>
                    <TableCell align="center" sx={{ width: "120px" }}>
                      <div
                        className={`invoice finan-status ${data.fin_status}`}
                      >
                        <span className="status-text">{data?.fin_status}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
}
